export const DEFAULT_LOCALE = "en";
export const LOCALES = ["en", "fa"];
export const RTL_LOCALES = ["fa"];
